export default {
	type: 'object',
	properties: {
		videoURL: { type: 'string' },
		timeStamp: { type: 'string' },
		projectUrl: { type: 'string' },
		notesForReviewer: { type: 'string', maxLength: 500 },
	},
	required: ['videoURL', 'timeStamp', 'projectUrl'],
	additionalProperties: false,
}
